import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./Abituriyentlar.module.css";

const Abituriyentlar = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.mainContainer}>
      <div className={classes.container}>
        <div className={classes.content}>
          <h1 className={classes.title}>{t("abituriyentlarga_eslatma")}</h1>
          
          <div className={classes.section}>
            <p className={classes.greeting}>{t("hurmatli_abituriyentlar")}</p>
            
            <p className={classes.intro}>
              {t("abituriyent_intro")}
            </p>
            
            <div className={classes.procedureSection}>
              <h2 className={classes.sectionTitle}>{t("royxatdan_otish_tartibi")}</h2>
              <ul className={classes.documentList}>
                <li>{t("royxatdan_otish_desc1")} (<a href="https://qabul.renessans-edu.uz/uz/auth" target="_blank" rel="noopener noreferrer">https://qabul.renessans-edu.uz/uz/auth</a>).</li>
                <li>{t("royxatdan_otish_desc2")}</li>
              </ul>
              
              <div className={classes.subList}>
                <p>{t("pasport_nusxasi")}</p>
                <p>{t("taʼlim_hujjati")}</p>
              </div>
            </div>

            <div className={classes.procedureSection}>
              <h2 className={classes.sectionTitle}>{t("qabul_jarayoni")}</h2>
              <ul className={classes.documentList}>
                <li>{t("qabul_desc")}</li>
              </ul>
              
              <div className={classes.examRequirements}>
                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("boshlangich_talim")}"</h4>
                  <p className={classes.examSubjects}>{t("boshlangich_fanlar")}</p>
                </div>
                
                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("maktabgacha_psixologiya")}"</h4>
                  <p className={classes.examSubjects}>{t("maktabgacha_fanlar")}</p>
                </div>
                
                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("tarix_yonalish")}"</h4>
                  <p className={classes.examSubjects}>{t("tarix_fanlar")}</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("milliy_goya")}"</h4>
                  <p className={classes.examSubjects}>{t("milliy_goya_fanlar")}</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("ingliz_tili")}"</h4>
                  <p className={classes.examSubjects}>{t("ingliz_fanlar")}</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("rus_tili")}"</h4>
                  <p className={classes.examSubjects}>{t("rus_fanlar")}</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("ozbek_tili")}"</h4>
                  <p className={classes.examSubjects}>{t("ozbek_fanlar")}</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("iqtisodiyot_yonalishlar")}"</h4>
                  <p className={classes.examSubjects}>{t("iqtisodiyot_fanlar")}</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("xalqaro_munosabatlar")}"</h4>
                  <p className={classes.examSubjects}>{t("xalqaro_fanlar")}</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("axborot_tizimlari")}"</h4>
                  <p className={classes.examSubjects}>{t("axborot_fanlar")}</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("xitoy_koreys")}"</h4>
                  <p className={classes.examSubjects}>{t("xitoy_fanlar")}</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"{t("dizayn_sport")}"</h4>
                  <p className={classes.examSubjects}>{t("dizayn_fanlar")}</p>
                </div>
              </div>

              <p className={classes.description}>
                {t("majburiy_fanlar")}
              </p>

              <ul className={classes.documentList}>
                <li>{t("imtihon_natija")}</li>
              </ul>
            </div>

            <div className={classes.procedureSection}>
              <h2 className={classes.sectionTitle}>{t("tolov_shartnoma")}</h2>
              <h3 className={classes.subTitle}>{t("shartnoma_tuzish")}</h3>
              <p className={classes.description}>
                {t("shartnoma_desc")}
              </p>
              <p className={classes.description}>
                {t("shartnoma_korsatiladi")}
              </p>
              
              <ul className={classes.contractList}>
                <li>{t("talim_shakli")}</li>
                <li>{t("oquv_yili")}</li>
                <li>{t("tolov_miqdori")}</li>
                <li>{t("huquq_majburiyat")}</li>
              </ul>

              <h3 className={classes.subTitle}>{t("tolov_miqdori_title")}</h3>
              <p className={classes.description}>
                {t("tolov_kontrakt_summasi")}
              </p>
              <ul className={classes.paymentList}>
                <li>{t("talim_yonalishi")}</li>
                <li>{t("talim_shakli_item")}</li>
                <li>{t("mutaxassislik_daraja")}</li>
              </ul>

              <h3 className={classes.subTitle}>{t("tolov_amalga_oshirish")}</h3>
              <p className={classes.description}>
                {t("tolov_bank")}
              </p>
              <p className={classes.description}>
                {t("tolov_usullari")}
              </p>
              <ul className={classes.paymentList}>
                <li>{t("bir_martalik")}</li>
                <li>{t("bosqichma_bosqich")}</li>
              </ul>

              <h3 className={classes.subTitle}>{t("tolov_oshirmaslik")}</h3>
              <ul className={classes.importantNotes}>
                <li>{t("tolov_chetlashtirish")}</li>
                <li>{t("tolov_uzaytirish")}</li>
              </ul>
            </div>

            <div className={classes.procedureSection}>
              <h2 className={classes.sectionTitle}>{t("muhim_eslatmalar")}</h2>
              <ul className={classes.importantNotes}>
                <li>{t("soxta_hujjat")}</li>
                <li>{t("oquv_shartlari")}</li>
              </ul>
            </div>

            <div className={classes.procedureSection}>
              <h2 className={classes.sectionTitle}>{t("qoshimcha_malumot")}</h2>
              <div className={classes.contactInfo}>
                <p><strong>{t("rasmiy_sayt")}</strong></p>
                <p><strong>{t("telefon_raqam")}</strong> 
                  <a href="tel:+998555067007" style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '8px', 
                    fontSize: '18px', 
                    fontWeight: '600',
                    color: 'inherit',
                    textDecoration: 'none'
                  }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                    </svg>
                    <span>+998 55 506 70 07</span>
                  </a>
                </p>
                <p><strong>{t("email_manzil")}</strong> <a href="mailto:info-rtu@renessans-edu.uz">info-rtu@renessans-edu.uz</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Abituriyentlar; 